import React from 'react';
import Select from '../Select/Select';
import { useMvpPartners } from '../../hooks/useMvpPartners';

interface RetailerSelectProps {
  value?: string;
  onChange?: (value: string) => void;
  required?: boolean;
  placeholder?: string;
}

export const RetailerSelect: React.FC<RetailerSelectProps> = ({
  value,
  onChange,
  required = false,
  placeholder = 'Select a retailer'
}) => {
  const { retailerOptions, isLoading, isError, error } = useMvpPartners();

  if (isError) {
    console.error('Error fetching retailers:', error);
  }

  return (
    <Select
      value={value}
      onChange={(value) => onChange?.(value)}
      required={required}
      options={retailerOptions}
      placeholder={isLoading ? 'Loading retailers...' : placeholder}
      isDisabled={isLoading || isError}
    />
  );
};
